import api from './api.js'

const profileUpdateEndpoint = "api/nutritionists/";
const profileUpdateImageEndpoint = "api/nutritionists/image/";
const favoriteEndpoint = "api/nutritionists/favorites";

export default {

  updateProfile(id,body) {
    return api.put(profileUpdateEndpoint+id,body);
  },
  uploadImage(id,body) {
    return api.postFile(profileUpdateImageEndpoint+id,body);
  },
  getFavorites(body){
    return api.get(favoriteEndpoint,body);
  },
  setFavorites(body){
    return api.post(favoriteEndpoint,body);
  }
}
